import React from 'react';
import styled from 'styled-components';
import Breathe from '../../components/Breathe/Breathe';


const Container = styled.div`
  display: flex;
  flex-direction:row;
  justify-content:space-between;
  width: 200px;
  height: 150px;
  border: none;
  border-radius: 9px;
  background-color: rgba(0,0,0,1);
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  overflow:hidden;
  position: relative;
  flex-shrink: 0 ;

`;

const Trend = styled.div`
  display: flex;
  flex-direction:row;
  width: 100%;
  height: auto;
  float:bottom;

`;

const Metriclg = styled.h3`
  font-size: 1.5rem;
  color: #ffffff;
  font-weight:300;
  margin-left:5px;
  justify-content:left;

  margin-top:0px;
  margin-bottom:0px;
`;
const Metricsm = styled.h3`
  font-size: 0.9rem;
  color: #ffffff;
  font-weight:300;
  margin-left:5px;
  justify-content:left;

  margin-top:0px;
  margin-bottom:0px;
`;

const Trendico = styled.img`
  margin-left:0px;
  margin-right:0px;
  justify-content:center;
  align-self:center;
  object-fit:contain;
  width:30px;
  height:30px;

`;

const Predico = styled.img`
  margin-left:0px;
  justify-content:center;
  align-self:center;
  object-fit:contain;
  width:15px;
  height:auto;
  margin-right:5px;
  margin-bottom:2px;
`;



const Pulse = styled.div`
  display: flex;
  flex-direction:row;
  width: 30px;
  height: 45px;
  float:bottom;
  justify-content: space-around;
`;

const Coverbg = styled.img`
  position: absolute;
  max-height: 100%;
  min-width: 100%;
  object-fit: cover;
  align-self:center; 
  border: none;
`;


const Inner01 = styled.div`
  display: flex;
  flex-start;
  flex-direction:column;

  height: auto;
  margin-left:10px;
  margin-top:10px;
  justify-content:left;
  position:absolute;
  z-index:1;

`;

const Column = styled.div`
  display: flex;
  flex-direction:column;

`;

const Tag = styled.span`
  font-size: 0.9rem;
  color: #13F9B2;
  text-transform: uppercase;
  line-height: 1.3;
  letter-spacing: 1px;
  justify-content:left;

`;

const Description = styled.p`
  font-family:roboto;
  font-size: 1.5rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.4em;
  letter-spacing: .6px;

  
`;


const ReusableMetricCard = (props) => {

  return(

  <Container>              

    <Inner01>
        
        <Tag>{props.tag}</Tag>
           
        <Description>{props.description}</Description>
        <Trend>
        <Pulse>
        <Trendico src = {props.trend}/>
        <Breathe/>
        </Pulse>
          <Column>
          <Metriclg>{props.metriclg}</Metriclg>
          <Metricsm>{props.metricsm}</Metricsm>
          </Column>
        </Trend>
  
    </Inner01>

   <Coverbg src= {props.coverbackground}/>
  </Container>

 );
}
export default ReusableMetricCard;